import {
	LeadEventApiDto, LeadQuoteFilesAttachedEventDataApiDto,
	LeadSurveyFilesAttachedEventDataApiDto
} from "../../../api/model/rest";
import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import Attachment from "../../attachment/Attachment";
import moment = require("moment");
import {Option, option} from "ts-option";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";

export default class LeadSurveyFilesAttachedEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param data lead quote files attached files event data
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadSurveyFilesAttachedEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadSurveyFilesAttachedEvent {
		const data = LeadSurveyFilesAttachedEventData.fromJson(json.data as LeadQuoteFilesAttachedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadSurveyFilesAttachedEvent(json.id,
			json.leadId,
			LeadEventTypeEnum.QuoteFilesAttached,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.File;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getAttachments(): Attachment[] {
		return this.data.attachments;
	}

	getActivityAdditionalMessages(): string[] {
		return this.data.surveyDescription.map(d => [d]).getOrElse([]);
	}

	getActivityType(): string {
		return `SURVEY`
	}

	getActivityMessage(): string {
		return "Files added";
	}

}

export class LeadSurveyFilesAttachedEventData {
	constructor(public readonly surveyId: string,
		public readonly attachments: Attachment[],
		public readonly surveyDescription: Option<string>) {}

	public static fromJson(json: LeadSurveyFilesAttachedEventDataApiDto): LeadSurveyFilesAttachedEventData {
		return new LeadSurveyFilesAttachedEventData(json.id, json.attachments.map(Attachment.fromJson), option(json.surveyDescription));
	}
}
